import { Button, Tooltip } from "@mui/material"
import type { SkillCatalogSkill } from "connected-components/skills/types"

const KELLY_ANSWERING_TOOLTIP = "Kelly is answering. Run is available once the answer finishes."

export interface SkillRunControl {
  onRun: (skill: SkillCatalogSkill) => void
  isKellyAnswering: boolean
}

interface SkillRunButtonProps {
  skill: SkillCatalogSkill
  enabled: boolean
  isSaving: boolean
  run: SkillRunControl
}

export function SkillRunButton({ skill, enabled, isSaving, run }: SkillRunButtonProps) {
  const label = enabled ? "Run" : "Turn on and run"
  return (
    <Tooltip title={run.isKellyAnswering ? KELLY_ANSWERING_TOOLTIP : ""}>
      <span>
        <Button
          size="small"
          variant="outlined"
          disabled={isSaving || run.isKellyAnswering}
          onClick={() => run.onRun(skill)}
          aria-label={`${label} ${skill.name}`}
          data-testid="kelly-skill-run"
        >
          {label}
        </Button>
      </span>
    </Tooltip>
  )
}
